export default __webpack_public_path__ + "static/media/ms_events.55b6248a.jpg";